'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _cms = require('actions/cms');

var initialState = {
  data: null,
  creative: null,
  technical: null,
  publishing: null,
  contact: null,
  projects: null,
  footer: null,
  loading: true
};

var cms = function cms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _cms.CMS_REQUEST:
      return _extends({}, state, {
        loading: true
      });
    case _cms.CMS_REQUESTED:
      return _extends({}, state, {
        loading: false
      });
    case _cms.CMS_RESULT:
      return _extends({}, state, {
        data: action.json,
        loading: false
      });
    case _cms.CREATIVE_RESULT:
      return _extends({}, state, {
        creative: action.json,
        loading: false
      });
    case _cms.FOOTER_RESULT:
      return _extends({}, state, {
        footer: action.json,
        loading: false
      });
    case _cms.TECHNICAL_RESULT:
      return _extends({}, state, {
        technical: action.json,
        loading: false
      });
    case _cms.PUBLISHING_RESULT:
      return _extends({}, state, {
        publishing: action.json,
        loading: false
      });
    case _cms.CONTACT_RESULT:
      return _extends({}, state, {
        contact: action.json,
        loading: false
      });
    case _cms.PROJECTS_RESULT:
      return _extends({}, state, {
        projects: action.json,
        loading: false
      });
    default:
      return state;
  }
};

exports.default = cms;


//////////////////
// WEBPACK FOOTER
// ./src/reducers/cms.js
// module id = 356
// module chunks = 1